import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { t } from '../../../../../modules/infra/i18n';
import Form from './DiscountForm';
import SimpleHeader from '../../../headers/simpleHeader';
import * as actions from '../actions';
import * as shapes from '../shapes';
import * as selectors from '../selectors';
import { trimFunction } from '../../../../common/trimData';

class Edit extends Component {
  onDelete = async () => {
    await this.props.onDelete();
    this.props.router.push(this.props.baseUrl); // eslint-disable-line
  }

  render() {
    return (
      <div>
        <SimpleHeader heading={t('settings:discounts.edit_discount_title')} />
        <Form
          initialValues={this.props.discount}
          onSubmit={trimFunction(this.props.onSubmit)}
          onDelete={this.onDelete}
          baseUrl={this.props.baseUrl}
          edit
        />
      </div>
    );
  }
}
Edit.propTypes = {
  onSubmit: shapes.handler.isRequired,
  onDelete: shapes.handler.isRequired,
  discount: shapes.discount.isRequired,
  baseUrl: shapes.url.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  shop: state.auth.shop,
  barberUser: state.auth.barberUser,
  discount: selectors.byId(state, ownProps.params.id),
  baseUrl: state.auth.barberUser ? '/barber/settings/discounts' : '/settings/discounts',
});

const mapDispatchToProps = {
  updateShopDiscount: actions.updateShopDiscount,
  updateBarberDiscount: actions.updateBarberDiscount,
  deleteShopDiscount: actions.deleteShopDiscount,
  deleteBarberDiscount: actions.deleteBarberDiscount,
};

const addHandlers = withHandlers({
  onSubmit: (props) => (data) => {
    if (props.barberUser) {
      return props.updateBarberDiscount(props.barberUser.id, data);
    }
    return props.updateShopDiscount(props.shop, data);
  },
  onDelete: (props) => () => {
    if (props.barberUser) {
      return props.deleteBarberDiscount(props.barberUser.id, props.params.id);
    }
    return props.deleteShopDiscount(props.shop, props.params.id);
  },
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  addHandlers
)(Edit);
